import { BeneficiaryRelationship } from "../../../../../../../../Wrap/Constants/Enums/Domain/BeneficiaryRelationship";

export class RelationshipMap {
    public static getString(relationship: BeneficiaryRelationship): string {
        if (!relationship) return null;
        return this.getMap().get(relationship);
    }

    public static getEnum(relationship: string): BeneficiaryRelationship {
        const map = this.getMap();

        let result: BeneficiaryRelationship;

        map.forEach((value: string, index: BeneficiaryRelationship) => {
            if (value === relationship) {
                result = index;
            }
        });

        return result;
    }

    public static getArray(): BeneficiaryRelationship[] {
        let options = [];
        options.push(BeneficiaryRelationship.Brother);
        options.push(BeneficiaryRelationship.Charity);
        options.push(BeneficiaryRelationship.Child);
        options.push(BeneficiaryRelationship.ChildInLaw);
        options.push(BeneficiaryRelationship.CivilPartner);
        options.push(BeneficiaryRelationship.CivilUnion);
        options.push(BeneficiaryRelationship.Cohabitant);
        options.push(BeneficiaryRelationship.Daughter);
        options.push(BeneficiaryRelationship.Dependant);
        options.push(BeneficiaryRelationship.FinancialDependant);
        options.push(BeneficiaryRelationship.Friend);
        options.push(BeneficiaryRelationship.Grandchild);
        options.push(BeneficiaryRelationship.LegalGuardian);
        options.push(BeneficiaryRelationship.Other);
        options.push(BeneficiaryRelationship.Owner);
        options.push(BeneficiaryRelationship.Parent);
        options.push(BeneficiaryRelationship.Partner);
        options.push(BeneficiaryRelationship.PartnerSpouse);
        options.push(BeneficiaryRelationship.Relative);
        options.push(BeneficiaryRelationship.Sibling);
        options.push(BeneficiaryRelationship.Sister);
        options.push(BeneficiaryRelationship.Son);
        options.push(BeneficiaryRelationship.Spouse);
        options.push(BeneficiaryRelationship.Trust);

        return options;
    }

    private static getMap(): Map<BeneficiaryRelationship, string> {
        const map = new Map<BeneficiaryRelationship, string>();

        map.set(BeneficiaryRelationship.NotSpecified, "Not Specified");
        map.set(BeneficiaryRelationship.Brother, "Brother");
        map.set(BeneficiaryRelationship.Charity, "Charity");
        map.set(BeneficiaryRelationship.Child, "Child");
        map.set(BeneficiaryRelationship.ChildInLaw, "Child In Law");
        map.set(BeneficiaryRelationship.CivilPartner, "Civil Partner");
        map.set(BeneficiaryRelationship.CivilUnion, "Civil Union");
        map.set(BeneficiaryRelationship.Cohabitant, "Cohabitant");
        map.set(BeneficiaryRelationship.Daughter, "Daughter");
        map.set(BeneficiaryRelationship.Dependant, "Dependant");
        map.set(BeneficiaryRelationship.FinancialDependant, "Financial Dependant");
        map.set(BeneficiaryRelationship.Friend, "Friend");
        map.set(BeneficiaryRelationship.Grandchild, "Grandchild");
        map.set(BeneficiaryRelationship.LegalGuardian, "Legal Guardian");
        map.set(BeneficiaryRelationship.Other, "Other");
        map.set(BeneficiaryRelationship.Owner, "Owner");
        map.set(BeneficiaryRelationship.Parent, "Parent");
        map.set(BeneficiaryRelationship.Partner, "Partner");
        map.set(BeneficiaryRelationship.PartnerSpouse, "PartnerSpouse");
        map.set(BeneficiaryRelationship.Relative, "Relative");
        map.set(BeneficiaryRelationship.Sibling, "Sibling");
        map.set(BeneficiaryRelationship.Sister, "Sister");
        map.set(BeneficiaryRelationship.Son, "Son");
        map.set(BeneficiaryRelationship.Spouse, "Spouse");
        map.set(BeneficiaryRelationship.Trust, "Trust");

        return map;
    }
}
